export default __webpack_public_path__ + "static/media/fontello.a31a7ebd.woff2";